<template>
  <q-card class="article-card">
    <q-item
      clickable
      class="q-pr-sm"
      @click="goToHref(article.url, false, false, 'width=1024,height=1024,left=300')"
    >
      <q-item-section
        top
        side
      >
        <q-icon :name="icon" />
      </q-item-section>
      <q-item-section>
        <q-item-label class="text-bold text-body1">
          {{ article.title }}
        </q-item-label>
        <q-item-label
          v-if="article.description"
          caption
          class="article-excerpt"
        >
          {{ article.description }}
        </q-item-label>
      </q-item-section>
    </q-item>
  </q-card>
</template>

<script>
export default {
  props: {
    article: {
      type: Object,
      required: true
    }
  },
  computed: {
    icon () {
      return this.article.icon || 'mdi-book'
    }
  }
}
</script>
